import React, { useEffect } from 'react';
import { Spin } from 'antd';
import styled from '@emotion/styled';
import { bool } from 'prop-types';
import { useFormContext, useForm } from 'react-hook-form';

const LoaderEl = styled.div`
  background: #ffffffcc;
  position: absolute;
  height: 100%;
  width: 100%;
  min-height: 600px;
  z-index: 100;

  justify-content: center;
  align-items: center;
  display: flex;
`;

export default function Loader({ isActive }) {
  if (isActive) {
    return (
      <LoaderEl>
        <Spin size="large" spinning={isActive} />
      </LoaderEl>
    );
  }
  return null;
}

Loader.propTypes = {
  isActive: bool,
};

Loader.defaultPropTypes = {
  isActive: true,
};
